import React, { Component } from 'react';
import { Container } from 'react-bootstrap';

import Header from './header';
import Footer from './footer';

import i18n from '../../i18n';

import './tos.css'

export default class Tos extends Component {

    constructor(props) {
        super(props);

        var tLang = 2;
        document.getElementsByTagName("html")[0].setAttribute("lang", "en")
        if (i18n.language == "hr") {
            document.getElementsByTagName("html")[0].setAttribute("lang", "hr")
            tLang = 1;
        }
    }


    render() {
        return (
            <React.Fragment>
                <Header />
                <main>
                    <Container fluid>


                        <br />
                        <br />
                        <br />
                        <br />
                        <div>
                            <br />
                            <br />
                            <br />
                            <br />
                            <section>
                                <Container>
                                    <h1>{i18n.t("tos:naslov")}</h1>
                                </Container>
                            </section>


                            <br />
                            <section>
                                <br />
                                <Container>
                                    <h2>{i18n.t("tos:uvod")}</h2>
                                    <br />
                                    <p>
                                        {i18n.t("tos:opci_uvjeti")}
                                    </p>

                                    <p>
                                        {i18n.t("tos:aplikacija_je_usluga_fine")}
                                        <br />
                                        {i18n.t("tos:aplikacija_je_javna")}
                                        <br />
                                        {i18n.t("tos:korisnik_podnosi")}
                                    </p>

                                    <p>
                                        {i18n.t("tos:korisnik_moze")}
                                    </p>
                                    <ul>
                                        <li>{i18n.t("tos:jednostavni_izvještaj")}</li>
                                        <li>{i18n.t("tos:detaljni_izvještaj")}</li>
                                        <li>{i18n.t("tos:dijagnostički_izvještaj")}</li>
                                    </ul>
                                    <p>
                                        {i18n.t("tos:izvjesca_fina")}
                                    </p>

                                    <p>
                                        {i18n.t("tos:ukupne_mogucnosti")}
                                    </p>

                                    <br />
                                </Container>
                            </section>

                            <section>
                                <br />
                                <Container>
                                    <h2>{i18n.t("tos:odgovornost")}</h2>
                                    <br />
                                    <p>
                                        {i18n.t("tos:korisnik_se_obvezuje")}
                                    </p>

                                    <p>
                                        {i18n.t("tos:korisnik_aplikacije_odgovoran")}
                                    </p>

                                    <p>
                                        {i18n.t("tos:vlasnik_svih_podataka")}
                                    </p>

                                    <p>
                                        {i18n.t("tos:fina_je_odgovorna")}
                                    </p>

                                    <p>
                                        {i18n.t("tos:reCaptcha")}
                                    </p>

                                    <p>
                                        {i18n.t("tos:osobni_podaci")}
                                    </p>

                                    <br />
                                </Container>
                            </section>

                            <section>
                                <br />
                                <Container>
                                    <h2>{i18n.t("tos:iskljucenje_odgovornosti")}</h2>
                                    <br />
                                    <p>
                                        {i18n.t("tos:fina_ne_snosi")}
                                    </p>

                                    <p>
                                        {i18n.t("tos:fina_ne_odgovara")}
                                    </p>

                                    <br />
                                </Container>
                            </section>

                            <section>
                                <br />
                                <Container>
                                    <h2>{i18n.t("tos:suglasnost")}</h2>
                                    <br />
                                    <p>
                                        {i18n.t("tos:fina_zadrzava_pravo")}
                                    </p>

                                    <p>
                                        {i18n.t("tos:korisnici_prihvacanjem")}
                                    </p>

                                    <br />
                                </Container>
                            </section>

                            <section>
                                <br />
                                <Container>
                                    <h2>{i18n.t("tos:rjesavanje_sporova")}</h2>
                                    <br />
                                    <p>
                                        {i18n.t("tos:fina_i_korisnik")}
                                    </p>
                                    <br />
                                </Container>
                            </section>

                        </div>
                        <br />

                    </Container >
                </main>
                <Footer />
            </React.Fragment>
        )
    }
}